// @flow
import { RNElementsTheme } from 'speed-js-rn';

export default {
    ...RNElementsTheme,
};
